























import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class AnswerMultiple extends Vue {
  public name = "AnswerMultiple";

  @Prop()
  public answer!: any;

  @Prop()
  public multipleQuestion!: any;

  private questionOptions: Array<any> = [];

  public get previewOnlyQuestion(): boolean {
    return !this.answer;
  }

  @Watch("multipleQuestion", { immediate: true, deep: true })
  public onMultipleQuestionChange(question: any): void {
    if (question && question.correctAnswer) {
      const questionCheckBoxes = question.correctAnswer.split(";");
      const answerCheckBoxes = !this.previewOnlyQuestion && this.answer[0].answer ? this.answer[0].answer.split(";") : [];
      this.questionOptions = question.options.map((opt: any, index: number) => {
        if (questionCheckBoxes.some((que: any) => Number(que) === opt.position)) {
          if (answerCheckBoxes.some((ans: any) => Number(ans) === opt.position)) {
            return { index: index, correct: true, checked: true, text: opt.text, questionChecked: true };
          }
          return { index: index, correct: false, checked: false, text: opt.text, questionChecked: true };
        }
        if (questionCheckBoxes.some((que: any) => Number(que) !== opt.position)) {
          if (answerCheckBoxes.some((ans: any) => Number(ans) === opt.position)) {
            return { index: index, correct: false, checked: true, text: opt.text, questionChecked: false };
          }
          return { index: index, correct: true, checked: false, text: opt.text, questionChecked: false };
        }
      });
    }
  }
}
